import axios from "axios";
import { appConstants } from "./appConstants";
export async function adjustmentRequest(
  kind,
  path = "",
  body,
  method = "post"
) {
  const response = await axios({
    method,
    url: `${appConstants.baseURL}${
      kind === "credit" ? "credit-notes" : "debit-notes"
    }${path}`,
    data: body,
  });
  if (!response.data?.Result_Status)
    throw new Error(
      response.data?.Result_Message || "Unable to complete this adjustment."
    );
  return response.data.Result_Output;
}
export async function loadNoteSources(direction, { q = "", id = "", onPage } = {}) {
  const query = new URLSearchParams({ direction, q, ...(id ? { id } : {}) });
  const sources = [];
  let page = 1,
    more = true;
  while (more && page <= 100) {
    const result = await adjustmentRequest(
      "credit",
      `/sources?${query}&page=${page}`,
      undefined,
      "get"
    );
    sources.push(...result.sources);
    onPage?.([...sources]);
    more = result.hasMore;
    page++;
  }
  return sources;
}
